unit share.common;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, XData.Web.Client,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, WEBLib.DB, WEBLib.Buttons, WebLib.Json,
  VCL.TMSFNCGridDatabaseAdapter;

type
  TPasswordMode = (pmLower, pmUpper, pmNumbers, pmExtra);
  TPasswordModes = set of TPasswordMode;

  TAccess = class
    const
      UsersSetup = 1;
      DieselSystem = 2;
      DieselOrder = 3;
      DieselInv = 4;
      DieselDepots = 5;
      DieselPrice = 6;
      DieselPriceC = 7;
      SubContractors = 8;
      DieselReports = 9;
      EmployeeSystem = 10;
      VehicleSystem = 11;
      HSEReports = 12;
      OpsReports = 13;
      DieselPay = 14;
      LoadconSystem = 15;
      WashbaySystem = 16;
      FullLoadCon = 17;
      LoadConInvoice = 18;
      Employee = 19;
      EmployeeReports = 20;
      PublicHolidays = 21;
      EmployeeHours = 22;
      ValidateHours = 23;
      ConfirmHours = 24;
      ClientActive = 25;
      Contracts = 26;
      LoadNonC = 27;
      LoadC = 28;
      CancelLoad = 29;
      ClientSystem = 30;
      CreateClient = 31;
      SystemSetup = 32;
      ControllFinPeriods = 33;
      FineSystem = 34;
      MaintenanceSystem = 35;
      NonConformance = 36;
      VehicleMain = 37;
      DailyCheckList = 38;
      AxleMassConfig = 39;
      VehicleUnitConfig = 40;
      CombinationConfig = 41;
      VehicleReports = 42;
      VehicleJobcards = 43;
      EmpYearsWeekDays = 44;
      OverSpeedingSystem = 45;
      EmpCounselling = 46;
      EmpWarnings = 47;
      EmpBriefing = 48;
      EmpPPE = 49;
      Loadcons = 50;
      LCCreditNoteSystem = 51;
      LCAllocateInv = 52;
      LCPaymentSystem = 53;
      LCReports = 54;
      LCUpdateInvLoads = 55;
      ClientPayReceive = 56;
      ClientUnAllPay = 57;
      ClientSites = 58;
      ClientWrietOff = 59;
      SubRemittance = 60;
      SubPayment = 61;
      SubUnAllPay = 62;
      SubAllPay = 63;
      SubWriteOff = 64;
      LCSLCN = 65;
      LCMLCN = 66;
      FuelAttendants = 67;
      FuelDepots = 68;
      FuelControlSheets = 69;
      FuelMonthEnd = 70;
      FuelCDN = 71;
      FuelUpdateInv = 72;
      FuelTankSetup = 73;
      FuelPriceChange = 74;
      FuelSuspendDepots = 75;
      VehCategories = 76;
      VehServiceTypes = 77;
      VehServiceHistory = 78;
      VehMoveHistory = 79;
      CompSites = 80;
      AutoEmail = 81;
      RegAccess = 82;
      PastelExport = 83;
      InvoiceLitres = 84;
      ExportToExcel = 85;
      RemContPrice = 86;
      OpenContPrice = 87;
      RemDieselPrice = 88;
      OpenDieselPrice = 89;
      Warehouse = 90;
      Locations = 91;
      Categories = 92;
      Waranties = 93;
      StockInfo = 94;
      StkSuppliers = 95;
      JCstock = 96;
      JCTyres = 97;
      PRstock = 98;
      PRTyres = 99;
      POstock = 100;
      POTyres = 101;
      POAstock = 102;
      POATyres = 103;
      PDstock = 104;
      PDTyres = 105;
      SuppInv = 106;
      StockTake = 107;
      StockTransfer = 108;
      StockRep = 109;
      CaptureMultiLoads = 110;
      LoadSupervisor = 111;
      DieselSupervisor = 112;
      RemittancePay = 113;
      NCRCreate = 114;
      NCRChange = 115;
      NCRClose = 116;
      NCRCostOrder = 117;
      NCRREOPEN = 118;
      NCRREPORT = 119;
      NCRSupervisor = 120;
      CAllLoads = 121;
      CUnAllLoads = 122;
      SAllLoads = 123;
      SUnAllLoads = 124;
      StockPriceC = 125;
      StockPriceO = 126;
      MaintenanceSupp = 127;
      ShowLoadSubRate = 128;
      ShowLoadClientRate = 129;
      TripScheduling = 130;
      LoadconPrintRate = 131;
      LoadCMI = 132;
      OweriteRecDate = 133;
      UnPayDiesel = 134;
      GraphL1 = 135;
      GraphL2 = 136;
      GraphL3 = 137;
      GraphL4 = 138;
      GraphL5 = 139;
      GraphL6 = 140;
      GraphL7 = 141;
      DieselPayment = 142;
      TollSystem = 143;
      TollRep = 144;
      ManRepSA = 145;
      ManRepVSA = 146;
      ManRepSSA = 147;
      TollProcessing = 148;
      NCRassessor = 149;
      ManRepVat = 150;
      ShowEmpRate = 151;
      NCRSignOff = 152;
      NCRGIT = 153;
      NCRGAT = 154;
      NCRGNT = 155;
      NCRGIC = 156;
      NCRGAC = 157;
      NCRGNC = 158;
      NCRGT5C = 159;
      NCRGT5D = 160;
      NCRGT5V = 161;
      SecureCN = 162;
      FuelSupp = 163;
      WashbayDepot = 164;
      WashbayProcess = 165;
      AllowManRep = 166;
      SuppCN = 167;
      GoodsRepair = 168;
      EmpClientReq = 169;
      EmpCompReq = 170;
      MiscTrans = 171;
      MiscInv = 172;
      MiscCN = 173;
      SubCPay = 174;
      SuppPay = 175;
      DieselPayments = 176;
      SupplierPayments = 177;
      SupplierAll = 178;
      ReconLoads = 179;
      OpenTrip = 180;
      LinkedLoadInv = 181;
      GetClientLoads = 182;
      ApproveSubInvoices = 183;
      SendElecInvoices = 184;
      LoadPlanningMain = 185;
      LoadPlanning = 186;
      PlanningSchedule = 187;
      ClosePlanning = 188;
      ContractOrders = 189;
      ProFormaInv = 190;
      LoadDebitnote = 191;
      vehgroups = 192;
      AssetFinJournal = 193;
      EmpPlanner = 194;
      SubAccount = 195;
      SuppRemit = 196;
      AllRemitPay = 197;
      UpfrontDiesel = 198;
      UpfrontMaint = 199;
      SuppReports = 200;
      ClientRep = 201;
      Fuelbulkorder = 202;
      FuelDebit = 203;
      OwnBulk = 204;
      WashReport = 205;
      WashDebit = 206;
      WashCredit = 207;
      CaptureFines = 208;
      FineReport = 209;
      AartoSched = 210;
      misccustinv = 211;
      misccustcred = 212;
      AssetBal = 213;
      VehCost = 214;
      VehAssetView = 215;
      UpgradeDatabase = 216;
      ChangeCancelLoads = 217;
      MaintRPInv = 218;
      MaintRPCN = 219;
      RevSupp = 220;
      RevCust = 221;
      AllowLoadCutOff = 222;
      AllowDieselCutOff = 223;
      OverrideSubTons = 224;
      SubsMultiInvoice = 225;
      FleetInfoScreen = 226;
      ViewInvoiceScreen = 227;
  end;

 TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDatabaseAdapter);

function GetRandomEmptyPos(const aStr: string): integer; inline;
function GeneratePassword(aLength: Integer; aModes: TPasswordModes): string;
//procedure DisplayMessageBox(sTitle, sMessage : String; ['Ok'])
function GetJsonFromDataSet(Dataset : TXDataWebDataSet) : String;
function GetJsonArrayFromDataSet(Dataset : TXDataWebDataSet; bLimitData : Boolean; sFieldName : String) : String;
function GetAdapterKey(dbaUnit : TTMSFNCGridDatabaseAdapter; iCol, iRow : Integer) : Integer;

implementation

function GetAdapterKey(dbaUnit : TTMSFNCGridDatabaseAdapter; iCol, iRow : Integer) : Integer;
    var
      d: TTMSFNCGridDataBaseAdapterOpen;
      ar, c, r: Integer;
      fName : TField;
  begin
    d := TTMSFNCGridDataBaseAdapterOpen(dbaUnit);
    if d.CheckDataSet then
      begin
        ar := d.DataLink.ActiveRecord;
        try
          d.SetActiveRecord(iRow);
          fName := d.FieldAtColumn[iCol];
          if Assigned(fName) then
            Result := fName.AsInteger;
        finally
          d.DataLink.ActiveRecord := ar;
        end;
      end;
  end;

function GetRandomEmptyPos(const aStr: string): integer; inline;
begin
  // find random empty position
  repeat
    Result := Random(Length(aStr)) + 1;
  until aStr[Result] = ' ';
end;

function GeneratePassword(aLength: Integer; aModes: TPasswordModes): string;
  const
    cLower   = 'abcdefghijklmnopqrstuvwxyz';
    cUpper   = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    cNumbers = '0123456789';
    cExtra   = '_.#@%$';
  var
    i,vPos: integer;
    vMode: TPasswordMode;
begin
  if (aLength = 0) or (aModes = []) then Exit;
  //Randomize;                                                                  //*GT 20230115 This must be Fixed!!!!

  // Prefill Result with empty spaces
  Result := StringOfChar(' ', aLength);

  // Add extra characters at random places
  for vMode in aModes do
  begin
    vPos := GetRandomEmptyPos(Result);
    case vMode of
      pmLower:    Result[vPos] := cLower[Random(Length(cLower)) + 1];
      pmUpper:    Result[vPos] := cUpper[Random(Length(cUpper)) + 1];
      pmNumbers:  Result[vPos] := cNumbers[Random(Length(cNumbers)) + 1];
      pmExtra:    Result[vPos] := cExtra[Random(Length(cExtra)) + 1];
    end;
  end;

  // Add random char on emtpy spaces
  for i := 1 to Result.Length do
    if Result[i] = ' ' then
      Result[i] := String(cLower + cNumbers)[Random(Length(cLower) + Length(cNumbers)) + 1];
end;

function GetJsonFromDataSet(Dataset : TXDataWebDataSet) : String;
  var
    JSObject : TJsonObject;
    i : Integer;
    Field : TField;
begin
  JSObject := TJsonObject.Create;

  For i := 0 to Dataset.Fields.Count - 1 do
    begin
      Field := Dataset.Fields[i];
      //If Field.IsNull then
        //JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create('null'))
      //else
        //begin
          case Field.DataType of
            ftString:
              JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create(Field.AsString));
            ftBoolean:
              JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONBool.Create(Field.AsBoolean));
            ftInteger:
              JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONNumber.Create(Field.AsInteger));
            ftFloat, ftCurrency:
              JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONNumber.Create(Field.AsFloat));
            ftDate, ftDateTime:
              JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create(FormatDateTime('yyyy-mm-dd"T"hh:nn:ss"Z"', Field.AsDateTime)));
            // Handle other field types as needed
          else
            JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create(Field.AsString));
          end;
        //end;
    end;
  Result := JSObject.ToString;
  JSObject.Free;
end;

function GetJsonArrayFromDataSet(Dataset : TXDataWebDataSet; bLimitData : Boolean; sFieldName : String) : String;
  var
    JSArray : TJsonArray;
    JSObject : TJsonObject;
    i : Integer;
    Field : TField;
begin
  JSArray := TJsonArray.Create;

  If bLimitData then
    begin
      Dataset.Filtered := False;
      Dataset.Filter := sFieldName + '=' + 'True' + '';
      Dataset.Filtered := True;
    end;
  Dataset.First;
  If not Dataset.IsEmpty then
    begin
      Repeat
        JSObject := TJsonObject.Create;

            For i := 0 to Dataset.Fields.Count - 1 do
              begin
                Field := Dataset.Fields[i];
                //If Field.IsNull then
                  //JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create('null'))
                //else
                  //begin
                    case Field.DataType of
                      ftString:
                        JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create(Field.AsString));
                      ftBoolean:
                        JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONBool.Create(Field.AsBoolean));
                      ftInteger:
                        JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONNumber.Create(Field.AsInteger));
                      ftFloat, ftCurrency:
                        JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONNumber.Create(Field.AsFloat));
                      ftDate, ftDateTime:
                        JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create(FormatDateTime('yyyy-mm-dd"T"hh:nn:ss"Z"', Field.AsDateTime)));
                      // Handle other field types as needed
                    else
                      JSObject.AddPair(StringReplace(Field.Name, Dataset.Name, '', [rfReplaceAll, rfIgnoreCase]), TJSONString.Create(Field.AsString));
                    end;
                  //end;
              end;
            JSArray.Add(JSObject);
            //JSObject.Free;
        DataSet.Next;
      Until DataSet.Eof;
    end;
  If Dataset.Filtered then
    Dataset.Filtered := False;
  Result := JSArray.ToString;
  JSArray.Free;
end;

end.
